import { t } from "@ebay/i18n-ebay";
import { UK } from "../../../../../common/constants";
$ const env = process.env.NODE_ENV;

<div class="header-container text-center">
  <div class="logo-section">
    <img
      data-testid="paypal-logo"
      id="logo"
      src=`${env === "production" ? "https://ir.ebaystatic.com/rs/v/lnftbw5msa5f3mg5qnjy2khifmr.png" : "https://securers.stratus.qa.ebay.com/rs/v/lnftbw5msa5f3mg5qnjy2khifmr.png"}`
      alt="PayPal Credit Logo"
    >
  </div>

  <div id="credits-header-container">
    <p class="credits-header" data-testid="header-credit">
      ${t("calculator/index", `HEADER_CREDIT_${input.site}`)}
    </p>
    <if(input.site == UK)>
      <p data-testid="header-or">
        - or -
      </p>
    </if>
    <p class="credits-footer" data-testid="footer-credit">
      ${t("calculator/index", `FOOTER_CREDIT_${input.site}`)}
    </p>
  </div>
</div>
